import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserApiService } from 'src/app/services/user.api.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  @ViewChild('adminLoginForm') adminLoginForm: NgForm
  
  email;
  password;

  constructor(private router: Router,
    private userApi: UserApiService,
    private loadr: NgxUiLoaderService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }
  onSubmit(form: any){
    const body = {
      email: form.email,
      password: form.password,
    }
    this.loadr.start();
    this.userApi.adminLogin(body).then((result) => {
      this.loadr.stop();
      this.toastr.success('Admin Login Successfully');
      this.router.navigate(['/admin/user-list']);
      this.adminLoginForm.reset();
      sessionStorage.setItem('kycLogin', JSON.stringify(result));
    }).catch((err) => {
      this.loadr.stop();
      this.toastr.error(err);
    });
  }
}
